import { useState } from 'preact/hooks';
import { ConfirmDialog } from './confirm-dialog';

interface DangerZoneProps {
  title: string;
  description: string;
  buttonLabel: string;
  onAction: () => void;
  confirmMessage?: string;
}

export function DangerZone({
  title,
  description,
  buttonLabel,
  onAction,
  confirmMessage,
}: DangerZoneProps) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleClick = () => {
    if (confirmMessage) {
      setConfirmOpen(true);
    } else {
      onAction();
    }
  };

  return (
    <div class="danger-zone">
      <h2>{title}</h2>
      <p>{description}</p>
      <button class="btn-danger btn-sm" onClick={handleClick}>
        {buttonLabel}
      </button>
      {confirmMessage && (
        <ConfirmDialog
          open={confirmOpen}
          title={title}
          message={confirmMessage}
          confirmLabel={buttonLabel}
          onConfirm={() => {
            setConfirmOpen(false);
            onAction();
          }}
          onCancel={() => setConfirmOpen(false)}
          isDestructive
        />
      )}
    </div>
  );
}
